import React from 'react';
import PropTypes from 'prop-types';
import ThumbDown from '@material-ui/icons/ThumbDown';
import {
    Button,
    useUpdateMany,
    useNotify,
    useRedirect,
    useUnselectAll,
    CRUD_UPDATE_MANY,
} from 'react-admin';

const BulkRejectButton = ({ selectedIds }) => {
    const notify = useNotify();
    const redirectTo = useRedirect();
    const unselectAll = useUnselectAll('tickets');

    const [reject, { loading }] = useUpdateMany(
        'tickets',
        selectedIds,
        {
          status: 'rejected',
        },
        {
            action: CRUD_UPDATE_MANY,
            undoable: true,
            onSuccess: () => {
                notify(
                    'resources.tickets.notification.approved_success',
                    'info',
                    {},
                    true
                );
                redirectTo('/tickets');
                unselectAll();
            },
            onFailure: () => {
                notify(
                    'resources.tickets.notification.approved_error',
                    'warning'
                );
            },
        }
    );

    return (
        <Button
            label="resources.invoices.action.reject"
            onClick={reject}
            disabled={loading}
        >
            <ThumbDown />
        </Button>
    );
};

BulkRejectButton.propTypes = {
    selectedIds: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export default BulkRejectButton;
